// Request Status Constants
export const REQUEST_STATUSES = {
  ADDITIONAL_INFORMATION_RECEIVED: "Additional Information Received",
  ADDITIONAL_INFORMATION_REQUIRED: "Additional Information Required",
  UNDER_REVIEW: "Under Review",
  ESCALATED: "Escalated",
  ACTION_TAKEN: "Action Taken",
  NO_ACTION_TAKEN: "No Action Taken",
  PARTIAL_ACTION_TAKEN: "Partial Action Taken",
  PENDING_REVIEW: "Pending Review",
  REVIEWED: "Reviewed",
  UNRESPONSIVE: "Unresponsive",
  // Add other request statuses here as needed
};

export const REQUEST_NOTES = {
  ADDITIONAL_DOCUMENTS_SUBMITTED: "Additional documents submitted",
};

export const LINE_ITEM_STATUS = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  MODIFY: "Modify"
};
